import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import edit from "../../images/edit.svg";
import Delete from "../../images/delete.svg";
import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { EditUserData } from "./adminComp/userEditModal";
import { 
  Search, 
  Calendar, 
  DollarSign, 
  Mail, 
  User,
  ChevronRight,
  Filter,
  Download,
  RefreshCw
} from "lucide-react";

function AdminPaymentHistory({ adminType }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(false);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchError, setSearchError] = useState("");

  const handleSearch = async () => {
    try {
      setSearchError("");
      if (searchMail) {
        let payload = {
          page: page,
          email: searchMail,
        };
        setLoader(true);
        const res = await api.getPaymentHistoryAdmin(payload);
        console.log(res);
        if (res?.success) {
          setData(res?.history);
          setnoOfUser(res.count);
          setLimit(res.limit);
          setLoader(false);
        } else {
          setSearchError("Email does not exist");
          setLoader(false);
        }
      } else {
        setSearchError("Please enter an email address to search");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setSearchError("Invalid email address format");
      setLoader(false);
    }
  };

  const handleClearSearch = () => {
    setSearchMail("");
    setSearchError("");
    // You might want to reload all data here
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  useEffect(() => {
    if (searchMail) {
      handleSearch();
    }
  }, [page]);

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid admin-payment-container">
        {/* Page Header */}
        <div className="payment-header">
          <div className="ph-content-header">
            <h1 className="page-title">
              Payment History
              {noOfUser > 0 && <span className="record-count">({noOfUser})</span>}
            </h1>
            <p className="page-subtitle">Track and manage user payment records</p>
          </div>
          
          {/* Stats Cards */}
          <div className="stats-container">
            <div className="stats-card">
              <div className="stat-icon-container revenue">
                <DollarSign size={20} color="#ffffff" />
              </div>
              <div className="stat-content">
                <h3 className="stat-value">
                  ${data.reduce((sum, item) => sum + (item?.amountPaid || 0), 0).toFixed(2)}
                </h3>
                <p className="label-stats">Total Revenue</p>
              </div>
            </div>
            
            <div className="stats-card">
              <div className="stat-icon-container transactions">
                <Calendar size={20} color="#ffffff" />
              </div>
              <div className="stat-content">
                <h3 className="stat-value">{data.length}</h3>
                <p className="label-stats">Transactions</p>
              </div>
            </div>
            
            <div className="stats-card">
              <div className="stat-icon-container users">
                <User size={20} color="#ffffff" />
              </div>
              <div className="stat-content">
                <h3 className="stat-value">
                  {new Set(data.map(item => item?.user?.email)).size}
                </h3>
                <p className="label-stats">Unique Users</p>
              </div>
            </div>
          </div>
        </div>

        {/* Search Section */}
        <div className="search-section">
          <div className="search-card">
            <div className="search-header">
              <h3 className="search-title">
                <Search size={18} className="search-icon" color="#667eea" />
                Search Payment Records
              </h3>
              <button 
                className="refresh-btn"
                onClick={handleClearSearch}
                title="Clear search"
              >
                <RefreshCw size={16} color="#718096" />
                Reset
              </button>
            </div>
            
            <div className="search-input-group">
              <div className="search-input-wrapper">
                <Mail size={18} className="input-icon" color="#a0aec0" />
                <input
                  type="email"
                  className="search-input"
                  placeholder="Enter user email address..."
                  value={searchMail}
                  onChange={(e) => setSearchMail(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
                <button 
                  className="ph-search-btn"
                  onClick={handleSearch}
                  disabled={loader}
                >
                  {loader ? "Searching..." : "Search"}
                </button>
              </div>
              
              {searchError && (
                <div className="error-message">
                  <span className="error-icon">!</span>
                  {searchError}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="table-section">
          <div className="table-header">
            <h3 className="table-title">
              <Calendar size={18} color="#2d3748" />
              Payment History
            </h3>
          </div>
          
          <Table
            data={data}
            setPage={setPage}
            page={page}
            noOfUser={noOfUser}
            limit={limit}
            adminType={adminType}
          />
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
      
      <style jsx>{`
        /* Main Container */
        .admin-payment-container {
          padding: 24px;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          min-height: 100vh;
        }
        
        /* Header Styles */
        .payment-header {
          padding: 12px;
          background: white;
          margin-bottom: 32px;
          border-radius: 16px;
        }
        
        .ph-content-header {
          padding-left: 10px;
          margin-bottom: 32px;
        }
        
        .page-title {
          color: #2d3748; /* Changed to black/dark gray */
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        
        .record-count {
          background: rgba(102, 126, 234, 0.1);
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 14px;
          font-weight: 500;
          color: #667eea;
        }
        
        .page-subtitle {
          color: #718096; /* Changed to dark gray */
          font-size: 16px;
          margin: 0;
        }
        
        /* Stats Cards */
        .stats-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
          gap: 20px;
          margin-bottom: 32px;
        }
        
        .stats-card {
          background: white;
          border-radius: 16px;
          padding: 24px;
          display: flex;
          align-items: center;
          gap: 16px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        
        .stats-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
        }
        
        .stat-icon-container {
          width: 56px;
          height: 56px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .stat-icon-container.revenue {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        }
        
        .stat-icon-container.transactions {
          background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
        }
        
        .stat-icon-container.users {
          background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
        }
        
        .stat-content {
          flex: 1;
        }
        
        .stat-value {
          font-size: 28px;
          font-weight: 700;
          color: #2d3748; /* Black text */
          margin: 0 0 4px 0;
          line-height: 1.2;
        }
        
        .label-stats {
          color: #718096; /* Dark gray */
          font-size: 14px;
          font-weight: 500;
          margin: 0;
        }
        
        /* Search Section */
        .search-section {
          margin-bottom: 32px;
        }
        
        .search-card {
          background: white;
          border-radius: 16px;
          padding: 24px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        }
        
        .search-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }
        
        .search-title {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 18px;
          font-weight: 600;
          color: #2d3748; /* Black text */
          margin: 0;
        }
        
        .search-icon {
          color: #667eea;
        }
        
        .refresh-btn {
          background: #f7fafc;
          border: 1px solid #e2e8f0;
          color: #718096; /* Dark gray text */
          padding: 8px 16px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        
        .refresh-btn:hover {
          background: #edf2f7;
          color: #4a5568; /* Darker gray on hover */
        }
        
        .search-input-group {
          position: relative;
        }
        
        .search-input-wrapper {
          display: flex;
          align-items: center;
          background: #f7fafc;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          padding: 4px;
          transition: border-color 0.2s ease;
        }
        
        .search-input-wrapper:focus-within {
          border-color: #667eea;
          background: white;
        }
        
        .input-icon {
          margin: 0 12px;
          color: #a0aec0;
        }
        
        .search-input {
          flex: 1;
          border: none;
          background: transparent;
          padding: 14px 12px;
          font-size: 15px;
          color: #2d3748; /* Black text */
          outline: none;
        }
        
        .search-input::placeholder {
          color: #a0aec0;
        }
        
        .ph-search-btn {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border: none;
          padding: 14px 28px;
          border-radius: 10px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        
        .ph-search-btn:hover:not(:disabled) {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
        }
        
        .ph-search-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        
        .error-message {
          background: #fff5f5;
          border: 1px solid #fed7d7;
          color: #c53030; /* Red error text */
          padding: 12px 16px;
          border-radius: 8px;
          margin-top: 12px;
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
        }
        
        .error-icon {
          background: #f56565;
          color: white;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
        }
        
        .search-hint {
          color: #718096; /* Dark gray */
          font-size: 13px;
          margin-top: 12px;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        
        .hint-icon {
          font-size: 14px;
        }
        
        /* Table Section */
        .table-section {
          background: white;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        }
        
        .table-header {
          padding: 24px;
          border-bottom: 1px solid #e2e8f0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .table-title {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 18px;
          font-weight: 600;
          color: #2d3748; /* Black text */
          margin: 0;
        }
        
        .table-actions {
          display: flex;
          gap: 12px;
        }
        
        .action-btn {
          padding: 10px 20px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 6px;
          cursor: pointer;
          transition: all 0.2s ease;
          border: 1px solid #e2e8f0;
          background: white;
          color: #4a5568; /* Dark gray text */
        }
        
        .action-btn:hover {
          background: #f7fafc;
          border-color: #cbd5e0;
        }
        
        .export-btn {
          color: #667eea;
        }
        
        .filter-btn {
          color: #718096;
        }
      `}</style>
    </>
  );
}

const Table = ({ data, page, setPage, noOfUser, limit, adminType }) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const checkSubscription = (nextPayment) => {
    let currentDate = new Date();
    let endDate = new Date(nextPayment);
    return currentDate < endDate;
  };

  function getInitials(username) {
    if (username) {
      const nameParts = username.split(" ");
      if (nameParts.length < 2) {
        return nameParts[0].charAt(0).toUpperCase();
      }
      const firstInitial = nameParts[0].charAt(0).toUpperCase();
      const lastInitial = nameParts[1].charAt(0).toUpperCase();
      return firstInitial + lastInitial;
    }
    return "U";
  }

  const getStatusColor = (date) => {
    return checkSubscription(date) ? "#48bb78" : "#f56565";
  };

  return (
    <>
      <div className="payment-table-container">
        {data.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon">
              <Calendar size={48} color="#cbd5e0" />
            </div>
            <h3 className="empty-state-title">No payment records found</h3>
            <p className="empty-state-description">
              {noOfUser === 0 
                ? "Start by searching for a user's payment history" 
                : "Try a different search query"}
            </p>
          </div>
        ) : (
          <>
            <div className="table-wrapper">
              <table className="payment-table">
                <thead>
                  <tr>
                    <th className="user-column">
                      <User size={16} color="#718096" />
                      User
                    </th>
                    <th className="amount-column">
                      <DollarSign size={16} color="#718096" />
                      Amount
                    </th>
                    <th className="type-column">Type</th>
                    <th className="date-column">
                      <Calendar size={16} color="#718096" />
                      Paid At
                    </th>
                    <th className="status-column">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, key) => (
                    <tr key={key} className="table-row">
                      <td className="user-cell">
                        <div className="user-info">
                          <div 
                            className="user-avatar"
                            style={{
                              background: `linear-gradient(135deg, #667eea 0%, #764ba2 100%)`
                            }}
                          >
                            {getInitials(item?.user?.name)}
                          </div>
                          <div className="user-details">
                            <div className="user-name">{item?.user?.name || "Unknown User"}</div>
                            <div className="user-email">{item?.user?.email}</div>
                          </div>
                        </div>
                      </td>
                      <td className="amount-cell">
                        <div className="amount-badge">
                          <DollarSign size={14} color="#667eea" />
                          {item?.amountPaid}$
                        </div>
                      </td>
                      <td className="type-cell">
                        <span className="type-label">Monthly</span>
                      </td>
                      <td className="date-cell">
                        <div className="date-info">
                          <div className="date-text">{formatDate(item?.createdAt)}</div>
                        </div>
                      </td>
                      <td className="status-cell">
                        <div 
                          className="status-badge"
                          style={{
                            backgroundColor: getStatusColor(item?.nextPaymentDate) === "#48bb78" 
                              ? "rgba(72, 187, 120, 0.1)" 
                              : "rgba(245, 101, 101, 0.1)",
                            color: getStatusColor(item?.nextPaymentDate)
                          }}
                        >
                          {checkSubscription(item?.nextPaymentDate) ? "Active" : "Expired"}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            {noOfUser > limit && (
              <div className="pagination-container">
                <div className="pagination-info">
                  Showing {((page - 1) * limit) + 1} - {Math.min(page * limit, noOfUser)} of {noOfUser} records
                </div>
                <Stack spacing={2}>
                  <Pagination
                    count={Math.ceil(noOfUser / limit)}
                    page={page}
                    onChange={handleChange}
                    shape="rounded"
                    color="primary"
                    sx={{
                      '& .MuiPaginationItem-root': {
                        borderRadius: '8px',
                        margin: '0 2px',
                      },
                      '& .MuiPaginationItem-page.Mui-selected': {
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                      }
                    }}
                  />
                </Stack>
              </div>
            )}
          </>
        )}
      </div>
      
      <style jsx>{`
        /* Table Container */
        .payment-table-container {
          padding: 0 24px 24px;
        }
        
        /* Empty State */
        .empty-state {
          padding: 64px 24px;
          text-align: center;
        }
        
        .empty-state-icon {
          color: #cbd5e0;
          margin-bottom: 16px;
        }
        
        .empty-state-title {
          font-size: 20px;
          font-weight: 600;
          color: #2d3748; /* Black text */
          margin-bottom: 8px;
        }
        
        .empty-state-description {
          color: #718096; /* Dark gray */
          font-size: 14px;
          margin: 0;
        }
        
        /* Table Styles */
        .table-wrapper {
          overflow-x: auto;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
           margin-top: 10px;
        }
        
        .payment-table {
          
          width: 100%;
          border-collapse: collapse;
          min-width: 800px;
        }
        
        .payment-table thead {
          background: #f7fafc;
          border-bottom: 2px solid #e2e8f0;
        }
        
        .payment-table th {
          padding: 16px 20px;
          text-align: left;
          font-size: 12px;
          font-weight: 600;
          color: #718096; /* Dark gray */
          text-transform: uppercase;
          letter-spacing: 0.5px;
          white-space: nowrap;
          border-bottom: 2px solid #e2e8f0;
        }
        
        .payment-table th svg {
          vertical-align: middle;
          margin-right: 8px;
          opacity: 1; /* Changed from 0.7 to 1 for better visibility */
        }
        
        .payment-table td {
          padding: 20px;
          border-bottom: 1px solid #f1f5f9;
        }
        
        .payment-table tbody tr:hover {
          background-color: #f8fafc;
        }
        
        /* User Cell */
        .user-cell {
          padding-left: 20px;
        }
        
        .user-info {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 600;
          font-size: 14px;
          flex-shrink: 0;
        }
        
        .user-details {
          min-width: 0;
        }
        
        .user-name {
          font-weight: 600;
          color: #2d3748; /* Black text */
          margin-bottom: 2px;
          font-size: 14px;
        }
        
        .user-email {
          color: #718096; /* Dark gray */
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        
        /* Amount Cell */
        .amount-cell {
          font-weight: 600;
          color: #2d3748; /* Black text */
        }
        
        .amount-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: rgba(102, 126, 234, 0.1);
          color: #667eea;
          padding: 8px 12px;
          border-radius: 8px;
          font-size: 14px;
        }
        
        /* Type Cell */
        .type-cell {
          color: #4a5568; /* Dark gray */
        }
        
        .type-label {
          background: #f1f5f9;
          color: #4a5568; /* Dark gray */
          padding: 6px 12px;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 500;
        }
        
        /* Date Cell */
        .date-cell {
          color: #4a5568; /* Dark gray */
        }
        
        .date-info {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        
        .date-text {
          font-size: 14px;
          color: #4a5568; /* Dark gray */
        }
        
        /* Status Cell */
        .status-badge {
          display: inline-flex;
          align-items: center;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        /* Pagination */
        .pagination-container {
          margin-top: 32px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 16px;
        }
        
        .pagination-info {
          color: #718096; /* Dark gray */
          font-size: 14px;
        }
        
        /* Responsive */
        @media (max-width: 768px) {
          .admin-payment-container {
            padding: 16px;
          }
          
          .stats-container {
            grid-template-columns: 1fr;
          }
          
          .search-input-wrapper {
            flex-direction: column;
            gap: 12px;
            background: white;
            padding: 16px;
          }
          
          .ph-search-btn {
            width: 100%;
            justify-content: center;
          }
          
          .table-header {
            flex-direction: column;
            gap: 16px;
            align-items: stretch;
          }
          
          .pagination-container {
            flex-direction: column;
            align-items: stretch;
          }
          
          .payment-table th,
          .payment-table td {
            padding: 12px 16px;
          }
        }
      `}</style>
    </>
  );
};

export default AdminPaymentHistory;